export const AppColors = {
  // KO Brand Colors - Primary
  koBrandRed: "#DC2626",
  koBrandBlack: "#1E1E1E",
  koBrandDarkGray: "#2F2F2F",
  koBrandLightGray: "#505050",

  themeColor_0A89AD: "#0A89AD",
  white: "#FFFFFF",
  black: "#000000",
  black_121212: "#0B0D13",
  black_18151b: "#18151b",
  appBlackColor_1e1e1e: "#1E1E1E",
  blue_1877F2: "#1877F2",
  orange_FA8F21: "#FA8F21",
  darkpink_D82D7E: "#D82D7E", 
  purple_9354BC: "#9354BC",
  red_FF2727: "#FF2727",
  lightBlack: "#FFFFFF1A",
  lightPurple_A897CD: "#A897CD",
  bgBlueColor_1B0D38: "#1B0D38",
  appBlueColor_3A5175: "#3A5175",
  appBlueColor_6949FF: "#6949FF",
  appViolentColor_6D08C3: "#DC2626",
  purple_6D08C333: "#6D08C333",
  lightPurple_604e74: "#604e74",
  appGrayColor_1C1C1C: "#1F2937",
  appGreenColor_51AF07: "#51AF07",
  blackTrans_000000a8: "#000000a8",
  gray_C3C3C3: "#C3C3C3",
  gray_A3A3A3: "#A3A3A3",
  gray_1E1E1E: "#1F2937",
  gray_C4C4C4: "#FFFFFF",
  gray_2a2a2a: "#2a2a2a",
  grayColor_484848: "#484848",
  grayColor_282828: "#1F2937",
  gray_F5F5F5: "#F5F5F5",
  grayColor_565656: "#1F2937",
  grayColor_999999: "#999999",
  grayColor_505050: "#505050",
  red_912121: "#912121",
  red_D43639: "#D43639",
  red_AF0707: "#AF0707",
  red_FA0A0A: "#FA0A0A",
  purple_9543ED: "#9543ED",
  purpleColor_9D2CF5: "#9D2CF5",
  black_282828: "#1F2937",
  black_999999: "#999999",
  grayColor_D9D9D9: "#D9D9D9",
  gray_7B7B7B: "#7B7B7B",
  grayColor_393939: "#393939",
  grayColor_333333: "#333333",
  purple_B155FF: "#B155FF",
  gray_1B1B1B: "#1F2937",
  gray_1F1F1F: "#1F2937",
  green_3D985E: "#3D985E",
  black_1D072D: "#1D072D",
  green_4CD964: "#4CD964",
  gray_5B5B5B: "#5B5B5B",
  gray_9F9F9F: "#9F9F9F",
  gray_212222: "#212222",
  gray_212121: "#212121",
  gray_171717: "#171717",
  gray_3f3f3f: "#3f3f3f ",
  gray_333333: "#333333",
  gray_757575: "#757575",
  yellow_E4AB3C: "#E4AB3C",
  gray_6E90B4: "#6E90B4",
  blue_5145E2: "#5145E2",
  white_C1C1C1: "#C1C1C1",
  gray_343434: "#343434",
  white_D6DDEB: "#D6DDEB",
  gray_2B2B2B: "#2B2B2B",
  gray_373737: "#373737",
  gray_6D6D6D: "#6D6D6D",
  blue_5575A8: "#5575A8",
  red_A23143: "#A23143",
  blue_165AB8: "#165AB8",
  gray_989898: "#989898",
  light_gray_8E8E8E: "#8E8E8E",
  red_EA3737: "#EA3737",
  purple_B136CF: "#B136CF",
  black_191919: "#1F2937",
  gray_4E555F: "#4E555F",
  gary_4E4E4E: "#4E4E4E",
  green_52FF6F: "#52FF6F",
  green_00FFE8: "#00FFE8",
  yellow_FFBF00: "#FFBF00",
  yellow_FACC15: "#FACC15",
  darkGray_595959: "#595959",
  gray_2F2F2F: "#2F2F2F",
  gray_727272: "#727272",
  white_B7C0CD: "#B7C0CD",
  yellow_F5F865: "#F5F865",
  red_ED1F24: "#ED1F24",
  green_32CD32: "#32CD32",
  red_FF3B5C: "#FF3B5C",
  purple_453B50: "#18202E",
  purple_9E77ED: "#9E77ED",
  gray_A6A3AA: "#A6A3AA",
  gray_828282: "#828282",
  purple_912BFF: "#912BFF",
  black_161719: "#161719",
  green_44aeb4: "#44aeb4",
  yellow_b69200: "#b69200",
  gray_E4E4E4: "#E4E4E4",
  gray_BBB: "#BBB",
  gray_5C5C5C: "#5C5C5C",
  purple_423B49: "#423B49",
  gray_838383: "#838383",
  white_D2D2D2: "#D2D2D2",
  gray_525252: "#525252",
  gary_645E6D: "#645E6D",
  gray_BABABA: "#BABABA",
  black_040404: "#040404",
  black_060506: "#060506",
  blue_051639: "#051639",
  gray_CECECE: "#CECECE",
  black_2D2733: "#2D2733",
  gray_D5D7DA: "#D5D7DA",
  gray_414651: "#414651",
  white_F6F6F6: "#F6F6F6",
  blue_2E68E8: "#2E68E8",
  gray_434343: "#434343",
  purple_635573: "#635573",
  purple_241A2E: "#241A2E",
  black_131016: "#131016",
  gray_474747: "#474747",
  blue_D6BBFB: "#D6BBFB",
  blue_6941C6: "#6941C6",
  blue_284CB8: "#284CB8",
  purple_6903CF: "#6903CF",
  purple_8A39CF: "#8A39CF",
  purple_40364A: "#40364A",
  gray_88888C: "#88888C",
  gray_B2B2B2: "#B2B2B2",
  purple_422464: "#422464",
  purple_C68DF6: "#C68DF6",
  gray_353535: "#353535",
  yellow_FF0: "#FF0",
  green_0DFF00: "#0DFF00",
  gray_4A4A4A: "#4A4A4A",
  gray_FFFFFF80: "#FFFFFF80",
  gray_B1B0B0: "#B1B0B0",
  red_FF0740: "#FF0740",
  yellow_FBEBBC: "#FBEBBC",
  blue_B0DEFF: "#B0DEFF",
  green_A5D6A7: "#A5D6A7",
  gray_424242: "#424242",
  green_00B536: "#00B536",
  green_15803D: "#15803D",
  gray_9CA3AF: "#9CA3AF",
  gray_8B93B0: "#8B93B0",
  green_14532D: "#14532D",
  green_16A34A: "#16A34A",
  green_4ADE80: "#4ADE80",
  gray_9499A4: "#9499A4",
  red_CF366E: "#CF366E",
  white_C3C3C3: "#C3C3C3",
  purple_6D28D9: "#6D28D9",
  purple_C084FC: "#C084FC",
  purple_C4B5FD: "#C4B5FD",
  gray_7E7E7E: "#7E7E7E",
  purple_322E37: "#322E37",
  blue_233DFF: "#233DFF",
  sidebarBackground_111827: "#111827",
  sidebarBorder_374151: "#374151",
  buttonRed_DC2626: "#DC2626",
  buttonRedDark_991B1B: "#991B1B",
  textWhite_FFFFFF: "#FFFFFF",
  backgroundGray_111827: "#111827",
  background_stream_setup: "#18202E80",
  blue_2196F3: "#2196F3",

  // Ranking Table Colors
  gray_374151: "#374151",
  gray_1F2937: "#1F2937",
  redOpacity_D1242430: "rgba(209, 36, 36, 0.30)",
};
